import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { PreloaderHandler, DOTS_FULL } from '../shared/preloader/preloader-handler';
import { NotificationHandlerService } from '../index';
import { OidcSecurityService } from '../auth/services/oidc.security.service';
import { App } from 'botframework-webchat';

@Component({
    selector: 'assistant-modal',
    templateUrl: 'assistant.component.html'
})

export class AssistantComponent implements AfterViewInit {

    public preloaderHandler: PreloaderHandler;
    private direct_line_secret = 'aHw7gBwQCyk.cwA.7EA.Te1mfF_kk7JUrd2Pw1IGAophWH9fyaSEWtmD5w7_PzE';
    public showChat = false;
    public fullScreen = false;
    private uData: any;

    constructor(private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {

        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, DOTS_FULL);
    }

    ngAfterViewInit(): void {
        this.oidcSecurityService.getUserData()
            .subscribe((data) => {
                this.uData = data;
                if (data != null) {
                    let userId = data.sub.toString();
                    let userName = data.name;
                    App({
                        directLine: { secret: this.direct_line_secret },
                        user: { id: 'Jared', name: userName },
                        bot: { id: 'botid' },
                        resize: 'detect'
                    }, document.getElementById('bot'));
                }
            });
    }

    public toggleChat(): void {
        this.showChat = !this.showChat;
    }

    public toggleFullScreen(): void {
        this.fullScreen = !this.fullScreen;
    }

}


// WEBPACK FOOTER //
// ./angularApp/app/assistant/assistant.component.ts